import classNames from 'classnames';
import { h, JSX } from 'preact';
import { useState } from 'preact/hooks';

import { CloseIcon, HamburgerIcon, UserIcon } from './Icons';
import { KinolaLogo } from './KinolaLogo';
import { LogoutForm } from './LogoutForm';
import { MenuItems, MenuState } from './Menu';

export const MobileMenu = (props: MenuState): JSX.Element => {
    const [isExpanded, setExpanded] = useState(false);

    const toggle = (): void => {
        setExpanded(!isExpanded);

        // Hide main content to solve various issues with scrolling, etc
        $('.k-main').toggleClass('k-main--mobile-menu-expanded', !isExpanded);
    };

    return (
        <div class={classNames('k-mobile-menu', { 'k-mobile-menu--expanded': isExpanded })}>
            <div class='k-mobile-menu__header'>
                <a class='k-mobile-menu__logo-container' href={props.header.dashboardUrl}>
                    <img class='k-mobile-menu__logo' src={props.header.logoUrl} alt='Logo Icon' />
                </a>
                <div class='k-mobile-menu__title'>
                    {props.header.title}
                </div>
                <div class='k-mobile-menu__button' onClick={toggle}>
                    {isExpanded ? <CloseIcon class='text-white'/> : <HamburgerIcon />}
                </div>
            </div>
            {isExpanded && (
                <div class='k-mobile-menu__body'>
                    <MenuItems {...props} className='k-mobile-menu__items' />
                    <div class='k-mobile-menu__secondary'>
                        <a class='k-mobile-menu__secondary-item' href={props.userMenu.profile.route}>
                            <UserIcon />
                            <div class='k-mobile-menu__secondary-text'>
                                {props.userMenu.profile.text}
                            </div>
                        </a>
                    </div>
                    <div class='k-mobile-menu__footer'>
                        <LogoutForm {...props.userMenu.logout} buttonClass='k-mobile-menu__logout' />
                        <KinolaLogo />
                    </div>
                </div>
            )}
        </div>
    );
};
